import { Box, Typography } from "@mui/material";
import { Eyebrow, Section } from "../ui/primitives";
import { colors } from "../ui/tokens";

// Opening band for inner pages: eyebrow, large title, lead paragraph.
export default function PageHero({ eyebrow, title, lead, children }) {
  return (
    <Section tone="warm" py={{ xs: 7, md: 11 }} sx={{ borderBottom: `1px solid ${colors.line}` }}>
      <Box sx={{ maxWidth: 860 }}>
        <Eyebrow>{eyebrow}</Eyebrow>
        <Typography variant="h1" component="h1" sx={{ color: colors.ink }}>{title}</Typography>
        {lead && (
          <Typography sx={{ mt: 3, fontSize: { xs: "1.05rem", md: "1.2rem" }, lineHeight: 1.65, color: colors.body, maxWidth: 720 }}>
            {lead}
          </Typography>
        )}
        {children}
      </Box>
    </Section>
  );
}
